import { loadAppSettings } from './appSettings';
import { registerRuntimeRemotes } from './designSystemRemote';

const REQUIRED_SETTINGS = [
  'SHIPBOB_DESIGN_SYSTEM',
  'SHIPBOB_MFE_RUNTIME',
  'AUTHENTICATION_AUTHORITY',
  'CLIENT_ID',
  'CLIENT_SCOPE',
  'LOAD_API_BASEURL',
  'LOAD_API_LOADSHIPMENTS',
  'LOAD_API_LOADSHIPMENTS_V2',
  'LOAD_API_UNITLOADS',
  'LOCATION_API_BASEURL',
  'ORDERFULFILLMENT_API_BASEURL',
  'WMS_LEGACY_API_BASEURL',
  'SORTING_CONFIGURATION_API_BASEURL',
  'ORDERFULFILLMENT_API_BULK_BOX',
  'ORDERS_API_BASEURL',
  'PACKINGSLIP_BASEURL',
  'LOCATIONMANAGEMENT_API_BASEURL',
  'LOAD_SHIPMENTS_DAYS_IN_PAST',
  'MFE_ROOT_ROUTE',
  'TRANSPORTATION_PERMISSION',
  'TRANSPORTATION_PERMISSION_NAME',
  'FREIGHT_BOOKING_PERMISSION',
  'FREIGHT_BOOKING_PERMISSION_NAME',
  'PICKUP_CONSOLIDATION_PERMISSION',
  'PICKUP_CONSOLIDATION_PERMISSION_NAME',
  'REDIRECT_LOCALSTORAGE_KEY',
];

/** Loads runtime settings, validates required values, and registers remotes. */
export async function prepareRuntime(action) {
  const appSettings = await loadAppSettings();

  const missing = REQUIRED_SETTINGS.filter(
    (key) => typeof appSettings[key] !== 'string' || !appSettings[key].trim(),
  );

  if (missing.length) {
    throw new Error(`[load-management-ui] cannot ${action}: missing required app settings: ${missing.join(', ')}`);
  }

  const missingRemotes = registerRuntimeRemotes(appSettings);
  if (missingRemotes.length) {
    throw new Error(`[load-management-ui] cannot ${action}: missing required runtime remotes: ${missingRemotes.join(', ')}`);
  }
}

/** Mounts the MFE only after runtime settings and remotes are prepared. */
export const mount = async (args = {}) => {
  await prepareRuntime('mount');
  const { mount: appMount } = await import('./bootloader');
  return appMount(args);
};
